import { yupResolver } from '@hookform/resolvers/yup';
import { Box, TextField } from '@mui/material';
import { useForm, FormProvider, SubmitHandler } from 'react-hook-form';
import { IRecruiterTeamNameAutoCompleteOption } from 'wisestep-api';
import { WsTypography, WsTypoVariants, WsTypoColors, WsButton } from 'wisestep-base';
import * as yup from 'yup';

import RecruiterSuggestions from '../../../components/filters/components/RecruiterSuggestions';

interface ISubmissionAssign {
  onBack: () => void;
  onSubmit: (data: AssignFormInputs) => void;
}

interface AssignFormInputs {
  recruiters: IRecruiterTeamNameAutoCompleteOption;
  comment: string;
}

const assignFormSchema = yup.object({
  recruiters: yup.object({
    email: yup.string().nullable(false).required('Recruiter email is required'),
  }),
  comment: yup.string().nullable(),
});

const SubmissionAssign = ({ onBack, onSubmit }: ISubmissionAssign) => {
  const methods = useForm<AssignFormInputs>({
    resolver: yupResolver(assignFormSchema),
    defaultValues: {
      recruiters: {} as IRecruiterTeamNameAutoCompleteOption,
      comment: '',
    },
  });

  const { register, handleSubmit, watch } = methods;
  const recruiter = (watch('recruiters') as IRecruiterTeamNameAutoCompleteOption) || {};

  const onFormSubmit: SubmitHandler<AssignFormInputs> = (data) => onSubmit(data);

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onFormSubmit)}>
        <Box display="flex" flexDirection="column" gap={2} mt={3}>
          <WsTypography variant={WsTypoVariants.SUB_TITLE} color={WsTypoColors.BLACK} bold>
            {`Add email to assign to other's queue`}
          </WsTypography>
          <Box display="flex" flexDirection="column" gap={1}>
            <WsTypography variant={WsTypoVariants.SUB_TITLE} color={WsTypoColors.BLACK}>
              Select user *
            </WsTypography>
            <RecruiterSuggestions
              name="recruiters"
              multiple={false}
              placeholder="Type to add email"
              requireRecruiter={true}
              value={recruiter?.email ?? ''}
            />
          </Box>
          <WsTypography variant={WsTypoVariants.SUB_TITLE} color={WsTypoColors.BLACK}>
            Comment
          </WsTypography>
          <TextField label="Comment" fullWidth multiline rows={4} {...register('comment')} />

          <Box display="flex" justifyContent="flex-end" gap={2} mt={2}>
            <WsButton variant="outlined" onClick={onBack}>
              Prev
            </WsButton>
            <WsButton variant="contained" type="submit">
              Submit
            </WsButton>
          </Box>
        </Box>
      </form>
    </FormProvider>
  );
};

export default SubmissionAssign;
